export function getFuncsOval(x: number, k: number, h: number, a: number, b: number): (() => number)[] {
    return [
        () => k - (b * Math.sqrt(1 - (((x - h) ** 2) / (a ** 2)))),
        () => k + (b * Math.sqrt(1 - (((x - h) ** 2) / (a ** 2)))),
    ];
}
